export default __webpack_public_path__ + "static/media/ts_logo.a0465cec.png";